<div class="open-bets-wrapper">
  @if (userName.includes("demo")) {
    <app-alert
      [config]="{
        title: 'Disclaimer',
        type: 'warning',
        subtitle: 'bet_disclaimer',
      }" />
  }
  @if (featureFlagService.featureFlags$ | async; as featureFlags) {
    @if (featureFlags["liveTV"] && router.url.includes("event-markets")) {
      <app-live-tv />
    }
  }
  <div class="slip-title bg-secondary text-primary slip-header">
    <span class="header-label"> BETSLIP </span>
    <div class="header-actions">
      @if (isDevOrUat) {
        <mat-icon (click)="balanceService.downloadBetsAndExposure()" class="action-icon">download</mat-icon>
      }
    </div>
  </div>

  @if (openBets().length === 0 && !currentParams) {
    <div class="empty-betslip-container">
      <div class="empty-content">
        <mat-icon class="receipt-icon">description</mat-icon>
        <p class="empty-text">No selections in the betslip</p>
      </div>
    </div>
  }
  @if (featureFlagService.featureFlags$ | async; as featureFlags) {
    @if (featureFlags["apiCallDuration"]) {
      <app-api-call-duration />
    }
  }
  <mat-accordion multi="true">
    @if (lapsedBets().length > 0) {
      <mat-expansion-panel class="exp-panel" [expanded]="true" hideToggle>
        <mat-expansion-panel-header class="exp-panel-header white-panel-indicator">
          <mat-panel-title class="exp-panel-title">
            Lapsed Bets
            <span class="count-badge">
              {{ lapsedBets().length }}
            </span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <app-matched-bets [data]="lapsedBets()" context="lapsed" />
      </mat-expansion-panel>
    }
    @if (unmatchedBets().length > 0) {
      <mat-expansion-panel class="exp-panel" [expanded]="true" hideToggle>
        <mat-expansion-panel-header class="exp-panel-header white-panel-indicator">
          <mat-panel-title class="exp-panel-title">
            <span>
              Unmatched Bets
              <span class="count-badge">
                {{ unmatchedBets().length }}
              </span>
            </span>
            @if (unmatchedBets().length > 1) {
              <button class="cancel-button" (click)="handleMultipleCancellation($event)">Cancel all</button>
            }
          </mat-panel-title>
        </mat-expansion-panel-header>
        <app-unmatched-bets [data]="unmatchedBets()" />
      </mat-expansion-panel>
    }
    @if (matchOddsBets().length > 0 || currentParams?.data?.context === "match-odds") {
      <mat-expansion-panel class="exp-panel" [expanded]="expandMatchOdds" hideToggle (expandedChange)="expandMatchOdds = $event">
        <mat-expansion-panel-header class="exp-panel-header white-panel-indicator">
          <mat-panel-title class="exp-panel-title">
            Main Market
            <span class="count-badge">
              {{ matchOddsBets().length }}
            </span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <app-matched-bets [data]="matchOddsBets()" context="match-odds" />
      </mat-expansion-panel>
    }
    @if (asianHandicapBets().length > 0 || currentParams?.data?.context === "asian-handicap") {
      <mat-expansion-panel class="exp-panel" [expanded]="expandAsianHandicap" hideToggle (expandedChange)="expandAsianHandicap = $event">
        <mat-expansion-panel-header class="exp-panel-header white-panel-indicator">
          <mat-panel-title class="exp-panel-title">
            Asian Handicap
            <span class="count-badge">
              {{ asianHandicapBets().length }}
            </span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <app-matched-bets [data]="asianHandicapBets()" context="asian-handicap" />
      </mat-expansion-panel>
    }
    @if (bookmakerBets().length > 0 || currentParams?.data?.context === "bookmaker") {
      <mat-expansion-panel class="exp-panel" [expanded]="expandBookmaker" hideToggle (expandedChange)="expandBookmaker = $event">
        <mat-expansion-panel-header class="exp-panel-header white-panel-indicator">
          <mat-panel-title class="exp-panel-title">
            Bookmaker
            <span class="count-badge">
              {{ bookmakerBets().length }}
            </span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <app-matched-bets [data]="bookmakerBets()" context="bookmaker" />
      </mat-expansion-panel>
    }
    @if (fancyBets().length > 0 || currentParams?.data?.context === "fancy") {
      <mat-expansion-panel class="exp-panel" [expanded]="expandFancy" hideToggle (expandedChange)="expandFancy = $event">
        <mat-expansion-panel-header class="exp-panel-header white-panel-indicator">
          <mat-panel-title class="exp-panel-title">
            Fancy
            <span class="count-badge">
              {{ fancyBets().length }}
            </span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <app-matched-bets [data]="fancyBets()" context="fancy" />
      </mat-expansion-panel>
    }
  </mat-accordion>
  @if (openBets().length > 0) {
    <button (click)="handleCopy()" color="primary" class="copy-btn" mat-mini-fab matTooltip="Copy All IDs" *featureFlag="'openBetsCopy'">
      <mat-icon>content_copy</mat-icon>
    </button>
  }
</div>
